import React, { useState, useEffect } from 'react';
import axios from 'axios';

function Home({ settings }) {
  const [content, setContent] = useState(null);

  useEffect(() => {
    fetchContent();
  }, []);

  const fetchContent = async () => {
    try {
      const response = await axios.get('/api/content');
      setContent(response.data);
    } catch (error) {
      console.error('Error fetching content:', error);
    }
  };

  if (!content) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <div className="home">
      <section className="hero">
        <h1>{content.home_hero?.title || 'Premium Car Detailing Services'}</h1>
        <h2>{content.home_hero?.subtitle || 'Professional care for your vehicle'}</h2>
        <p>{content.home_hero?.description || 'We provide the highest quality car detailing services.'}</p>
      </section>

      <div className="container">
        <section className="section">
          <h2>{content.home_about?.title || 'About Us'}</h2>
          <p>{content.home_about?.text || 'With years of experience in car detailing, we pride ourselves on delivering exceptional results.'}</p>
        </section>
      </div>
    </div>
  );
}

export default Home;
